import { UserMicrocertificateDTO } from '@/services/undergrad/pegasus-pepe-legal/microcertificates.service';

export interface MicrocertificateState {
  microcertificates: UserMicrocertificateDTO[];
  isGenerating: boolean;
  currentMicrocertificateFiles: {
    pdfUrl?: string;
    pngUrl?: string;
  };
  currentMicrocertificateHash: string;
  displayingMicrocertificates: string[];
  acceptsMicrocertificateAutoPopup: boolean;
}

const state: MicrocertificateState = {
  microcertificates: [],
  isGenerating: false,
  currentMicrocertificateFiles: {},
  currentMicrocertificateHash: '',
  displayingMicrocertificates: [],
  acceptsMicrocertificateAutoPopup: true,
};

export default state;
